export default __webpack_public_path__ + "static/media/logo.b79fe51e.svg";